import { ServiceInvoiceType } from "@redotech/redo-model/billing/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const startBilling = {
  name: "startBilling" as const,
  input: z.object({
    teamId: zExt.objectId(),
    type: createEnum(ServiceInvoiceType),
  }),
  output: z.null(),
};
